import { LocalizedEnum } from '@api/journodex/model/localized-enum';
import { SortFieldEnum } from '../enum/SortField.enum';

export const OUTLET_SORT_FIELDS: LocalizedEnum[] = [
    {
        enumValue: SortFieldEnum.CIRCULATION_UNIQUE_VISITORS,
        displayString: 'Discover.targeting.sortFields.uniqueVisitors'
    },
    {
        enumValue: SortFieldEnum.CIRCULATION_CIRCULATION,
        displayString: 'Discover.targeting.sortFields.circulation'
    },
    {
        enumValue: SortFieldEnum.CIRCULATION_VIEWERS,
        displayString: 'Discover.targeting.sortFields.viewers'
    },
    {
        enumValue: SortFieldEnum.CIRCULATION_LISTENERS,
        displayString: 'Discover.targeting.sortFields.listeners'
    },
    {
        enumValue: SortFieldEnum.CIRCULATION_FOLLOWERS,
        displayString: 'Discover.targeting.sortFields.followers'
    },
    {
        enumValue: SortFieldEnum.OUTLET_NAME,
        displayString: 'Discover.targeting.sortFields.outletName'
    },
    {
        enumValue: SortFieldEnum.COUNTRY_NAME,
        displayString: 'Common.country'
    },
    {
        enumValue: SortFieldEnum.PROVINCE_NAME,
        displayString: 'Common.province'
    },
    {
        enumValue: SortFieldEnum.CITY_NAME,
        displayString: 'Common.city'
    }
];
